import flatpickr from 'flatpickr';
import { German } from "flatpickr/dist/l10n/de.js";

export default class DatePicker {

	static init() {
		document.querySelectorAll('input[type="date"]').forEach((input) => {
			const date = input.getAttribute('value');
			const minDate = input.getAttribute('data-min-date');
			const maxDate = input.getAttribute('data-max-date');
	
			let options = {
				locale: German,
				dateFormat: 'd.m.Y',
				disableMobile: true
			};
	
			if(minDate) options.minDate = minDate;
			if(minDate) options.maxDate = maxDate;
	
			const datePicker = flatpickr(input, options);
			datePicker.setDate(date);
		});
	}
}